import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsObsstudioComponent } from './simple-icons-obsstudio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsObsstudioComponent ],
    exports:      [ SimpleIconsObsstudioComponent ],
    bootstrap:    []
})
export class SimpleIconsObsstudioModule {}
